<template>
    <v-flex x16 class="sortable-handler">
    <v-card>
    <v-dialog v-model="showModal" hide-overlay transition="dialog-bottom-transition" class="sortable-handler">
        <v-card>
        <v-toolbar dark style="background-color:#138315">
            <v-toolbar-title>{{ itemEdit ? 'Edit' : 'Create' }} Devices</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
            <v-btn icon dark @click="closeModalCreate()">
                <v-icon>close</v-icon>
            </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-layout row wrap class="pa-4">
            <v-flex xs12 >
            <v-card class="pa-2">
                <v-flex xs4 align-center offset-xs4>
                <v-select
                  :disabled="disabledList"
                  :items="items"
                  item-text="name"
                  v-model="select"
                  label="Select a Client for devices"
                  return-object
                ></v-select>
                </v-flex>
            </v-card>
            </v-flex>
            <v-flex xs6 class="pa-1" v-if="!itemEdit">
            <v-card class="pa-2">
                <h4>Import Excel</h4>
                <v-text-field label="Search file" readonly @click="pickFile" v-model="excelName" prepend-icon="attach_file" data-vv-name="file excel"></v-text-field>
                <input type="file" style="display: none" ref="excelInput" accept=".xlsx" @change="onFilePicked">
                <p class="font-weight-light text-md-center">If you need format for upload excel, click <a :href="urlDownloadExcel" target="_bank"> <strong>¡HERE!</strong></a> and Download</p>
                <v-flex class="text-xs-right" shrink>
                <v-btn color="primary" dark class="text-md-left text-sm-left" :disabled="disabledUpload" @click="uploadDevices">
                    Upload
                </v-btn>
                </v-flex>
            </v-card>
            </v-flex>
            <v-flex xs6 :offset-xs3="disabledList" class="pa-1">
            <v-card class="pa-2">
                <h4>{{ itemEdit ? 'Update' : 'Register' }}</h4>
                <v-form ref="storeData" @submit.prevent="storeData()">
                  <v-text-field v-model="name" label="Name" v-validate="'required|max:75'" :error-messages="errors.collect('name')" data-vv-name="name"></v-text-field>
                  <v-text-field v-model="reference" label="Reference" :error-messages="errors.collect('reference')" data-vv-name="reference"></v-text-field>
                  <v-flex xs12>
                  <v-radio-group v-model="type" row class="mt-0 mb-0 pb-0 pt-0" v-if="!itemEdit">
                  <span class="ml-2 mr-2 mt-0 mb-0"> Type Token </span>
                  <v-radio label="Random" value="random" class="mb-0"></v-radio>
                  <v-radio label="Custom" value="custom" class="mb-0"></v-radio>
                  </v-radio-group>
                  </v-flex>
                  <v-text-field class="mb-0 mt-0" v-model="token" label="Token" :error-messages="errors.collect('token')" data-vv-name="token" :disabled="tokenDisabled"></v-text-field>
                  <v-flex xs12>
                  <v-radio-group v-model="init_survey" row class="mt-0 mb-0">
                  <span class="ml-2 mr-2 mt-0 mb-0"> Init Surveys </span>
                  <v-radio label="Random" value="random"></v-radio>
                  <v-radio label="Switch" value="switch"></v-radio>
                  <v-tooltip top>
                    <v-btn slot="activator" icon>
                      <v-icon color="grey lighten-1">info</v-icon>
                    </v-btn>
                    <span><strong>Switch</strong> is to obtain the list of surveys associated to the device in start of the survey. <br>
                    <strong>Random</strong> is obtain a survey  from the list of associate to device for start of the survey directly.</span>
                  </v-tooltip>
                  </v-radio-group>
                  </v-flex>
                  <v-flex class="text-xs-right" shrink>
                    <v-btn color="primary" dark class="text-md-left text-sm-left" type="submit">
                        Save
                    </v-btn>
                  </v-flex>
                </v-form>
            </v-card>
            </v-flex>
        </v-layout>
        </v-card>
    </v-dialog>
    </v-card>
    </v-flex>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    showExcel: {
      type: Boolean,
      required: false,
      default: true
    },
    itemEdit: {
      type: Object,
      required: false,
      default: null,
    }
  },
  data () {
    return {
      select: '',
      showModal: true,
      name: null,
      token: null,
      reference: null,
      type: 'random',
      init_survey: 'random',
      excelName: '',
      excelFile: null,
      items: [],
      disabledUpload: true,
      urlDownloadExcel: window.axios.defaults.baseURL + '/download-excel-devices-format'
    };
  },
  computed: {
    tokenDisabled () {
      this.token = null;
      return this.type === 'random';
    },
    disabledList () {
      return this.itemEdit ? true : false;
    },
  },
  mounted () {
    this.loadData();
  },
  methods: {
    closeModalCreate () {
      this.$emit('closeModal');
    },
    pickFile () {
      this.$refs.excelInput.click();
    },
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.excelName = files[0].name;
        this.disabledUpload = true;
        if (this.excelName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.excelFile = files[0];
          this.disabledUpload = false;
        });
      } else {
        this.excelName = '';
        this.excelFile = '';
        this.disabledUpload = true;
      }
    },
    uploadDevices () {
      let formData = new FormData();
      formData.append('file', this.excelFile);
      formData.append('client_id', this.select.id);
      let url = '/devices/upload-excel';
      window.axios.post(url, formData).then(response => {
        this.$emit('openModalSummary', response.data);
        this.closeModalCreate();
      }, response => {
        this.$store.dispatch('setSnackbar', {
          show: true,
          color: 'error',
          text: 'Server Error'
        });
      });
    },
    loadData () {
      let url = '/devices/create';
      window.axios.get(url).then((response) => {
        this.items = response.data.clients;
        this.select = this.items[0];
        if (this.itemEdit) {
          this.editData();
        }
        this.$store.commit('setLoading', false);
      });
    },
    editData () {
      this.name = this.itemEdit.name;
      this.reference = this.itemEdit.reference;
      this.token = this.itemEdit.token;
      this.init_survey = this.itemEdit.init_survey;
      this.select = this.itemEdit.client;
      this.type = 'custom';
    },
    storeData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.itemEdit) {
            const payload = {
              name: this.name,
              init_survey: this.init_survey,
              token: this.token,
              reference: this.reference
            };
            let url = '/devices/' + this.itemEdit.id;
            window.axios.put(url, payload).then(response => {
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'success',
                text: 'Device update successfully.'
              });
              response.data.data.index = this.index;
              this.$emit('updateDevice', { 'value': response.data.data, 'index': this.itemEdit.index });
              this.closeModalCreate();
            }, response => {
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'error',
                text: 'Server Error'
              });
            });
          } else {
            let url = '/devices';
            const payload = {
              client_id: this.select.id,
              name: this.name,
              type: this.type,
              init_survey: this.init_survey,
              token: this.token,
              reference: this.reference
            };
            window.axios.post(url, payload).then((response) => {
              this.$store.commit('setLoading', false);
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'success',
                text: 'Device saved successfully.'
              });
              this.$emit('addDevice', response.data.data);
              this.closeModalCreate();
            }).catch(error => {
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'error',
                text: 'Server Error'
              });
            });
          }
        } else {
          this.$store.dispatch('setSnackbar', {
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    },
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
  .color{
    display: block;
    width: 50px;
    height: 20px;
  }
  .sortable-handler {
    touch-action: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/devices/ModalCreate.vue